import { useState } from "react";

/**
 * The value, or the last one it had while it's null, so a dialog or sheet
 * closed by clearing its target keeps its content through the exit animation.
 */
export const useHeld = <T>(value: T | null | undefined): T | null => {
  const [held, setHeld] = useState<T | null>(value ?? null);
  if (value != null && value !== held) setHeld(value);
  return value ?? held;
};
